import { render, staticRenderFns } from "./SideBar.vue?vue&type=template&id=301b67bc&scoped=true&"
import script from "./SideBar.js?vue&type=script&lang=js&"
export * from "./SideBar.js?vue&type=script&lang=js&"
import style0 from "./SideBar.vue?vue&type=style&index=0&id=301b67bc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "301b67bc",
  null
  
)

export default component.exports